const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async createParts({ rootState }, params = {}) {
      const data = await rootState.http("/parts/createParts", params);
      return data;
    },
    async getPartsList({ rootState }, params = {}) {
      const data = await rootState.http("/parts/queryPartsList", params);
      return data;
    },
    async getPartsInventoryList({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/queryPartsInventory", { findTemporaryParts: "1", ...params });
      return data;
    },
    async getPartsDetail({ rootState }, params = {}) {
      const data = await rootState.http("/parts/getParts", params);
      return data;
    },
    async updateParts({ rootState }, params = {}) {
      const data = await rootState.http("/parts/updateParts", params);
      return data;
    },
    async updateStatus({ rootState }, params = {}) {
      const data = await rootState.http("/parts/updatePartsStatusList", params);
      return data;
    },
    async getPartsBrandList({ rootState }, params = {}) {
      const data = await rootState.http("/parts/brand/queryBrandList", params);
      return data;
    },
    async createBrand({ rootState }, params = {}) {
      const data = await rootState.http("/parts/brand/saveBrand", params);
      return data;
    },
    async partsInventoryMove({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/inventoryMove", params);
      return data;
    },
    async saveTempParts({ rootState }, params = {}) {
      const data = await rootState.http("/parts/saveTempParts", params);
      return data;
    }
  }
};

export default store;
